import React, { useEffect, useState } from 'react';
import { Flex } from 'rebass';
import { keyframes } from '@emotion/react';
import { useUploadBatchCounts } from 'story-media/upload-manager/hooks';
import { ReactComponent as BabysFYLabel } from 'babys-first-year/assets/babyyearbookslabel.svg';

const rotate = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(0);  }
`;

const Wrapper = ({ children, noOfTransitions = 0, ...props }) => {
    const { success, error, uploading } = useUploadBatchCounts();
    const isUploading = !!uploading || !!success || !!error
    const [animationStyle, setAnimationStyle] = useState({});

    const animateElement = () => {
        setAnimationStyle((prevStyle) => ({
            ...prevStyle,
            opacity: 0,
            animation: 'unset',
        }));

        setTimeout(() => {
            setAnimationStyle((prevStyle) => ({
                ...prevStyle,
                opacity: 1,
                animation: `${rotate} 1s ease`,
            }));
        }, 500);
    };

    useEffect(() => {
        animateElement()
    }, [noOfTransitions])

    return (
        <Flex bg="white" flexDirection='column' width="100%" height='100vh' sx={{ position: 'fixed', bottom: 0, top: 0, overflowY: 'auto' }}>
            <Flex p={2} justifyContent={'space-between'} alignItems="center" >
                <Flex width={['160px', '300px', "100%"]}>
                    <BabysFYLabel />
                </Flex>
            </Flex>
            <Flex
                sx={animationStyle}
                flexDirection="column"
                maxWidth={500}
                m="auto"
                mt={isUploading ? ['70px', '50px'] : ['10px', '30px']}
                mb="60px"
                {...props}
            >
                {children}
            </Flex>
        </Flex>
    );
};

export default Wrapper;
